import { useState, useEffect, useRef } from 'react'
import { dashboardService, DashboardStats, RecentActivity, BotStatus } from '../services/dashboardService'

export const useDashboard = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null)
  const [activities, setActivities] = useState<RecentActivity[]>([])
  const [botsStatus, setBotsStatus] = useState<BotStatus[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const isLoadingRef = useRef(false)
  const hasInitializedRef = useRef(false)

  const loadDashboardData = async () => {
    if (isLoadingRef.current) return

    try {
      isLoadingRef.current = true
      setIsLoading(true)
      setError(null)

      // Carregar estatísticas
      const statsResult = await dashboardService.getStats()
      if (statsResult.success && statsResult.data) {
        setStats(statsResult.data)
      }

      // Carregar atividades recentes
      const activitiesResult = await dashboardService.getRecentActivities()
      if (activitiesResult.success && activitiesResult.data) {
        setActivities(activitiesResult.data)
      }

      // Carregar status dos bots
      const botsResult = await dashboardService.getBotsStatus()
      if (botsResult.success && botsResult.data) {
        setBotsStatus(botsResult.data)
      }

    } catch (error) {
      setError('Erro ao carregar dados do dashboard')
    } finally {
      isLoadingRef.current = false
      setIsLoading(false)
    }
  }

  const refreshData = () => {
    loadDashboardData()
  }

  useEffect(() => {
    // Evita duplicidade de chamada no React StrictMode em desenvolvimento.
    if (import.meta.env.DEV && hasInitializedRef.current) return
    hasInitializedRef.current = true
    loadDashboardData()
  }, [])

  return {
    stats,
    activities,
    botsStatus,
    isLoading,
    error,
    refreshData
  }
}




